export function getLogoUrl(logocup) {
  if (!logocup) return null

  try {
    // Если это относительный путь
    if (logocup.startsWith('/')) {
      return `https://www.protocarp.ru${logocup}`
      //     return `https://www.admin-protocarp.ru${logocup}`
    }

    // Если это уже полный URL
    if (logocup.startsWith('http')) {
      return logocup
    }

    // Дефолтный случай     return `https://www.admin-protocarp.ru/logo/${logocup}`
    return `https://www.protocarp.ru/logo/${logocup}`
  } catch {
    return null
  }
}
